import { Box } from '@mui/material';
import { TextBlock, TextSpan } from '../../../Atoms/Text';
import { DiscoveryAnswer, DiscoveryQuestion } from '../../../../types/advise';
import { DiscoveryAnswerInput } from './DiscoveryAnswerInput';
import { DiscoveryNotesBox } from './DiscoveryNotesBox';
import { DiscoveryReadOnlyAnswer } from './DiscoveryReadOnlyAnswer';

interface DiscoveryQuestionFieldProps {
  question: DiscoveryQuestion;
  canEdit: boolean;
  onAnswer: (value: DiscoveryAnswer) => void;
}

export const DiscoveryQuestionField = ({ question, canEdit, onAnswer }: DiscoveryQuestionFieldProps) => (
  <Box
    className="py-4"
    sx={{ borderBottom: 1, borderColor: 'divider' }}
    data-testid={`discovery-question-${question.key}`}>
    <Box className="flex items-start justify-between gap-4 mb-2">
      <TextBlock
        size="sm14"
        weight="semibold"
        color="grey8">
        {question.label}
      </TextBlock>
      <TextSpan
        size="xs"
        weight="medium"
        color={question.required ? 'red' : 'grey5'}
        className="shrink-0">
        {question.required ? '* Required' : 'Optional'}
      </TextSpan>
    </Box>
    {canEdit ? (
      <>
        <DiscoveryAnswerInput
          question={question}
          onAnswer={onAnswer}
        />
        {question.has_notes && (
          <Box className="mt-2">
            <DiscoveryNotesBox
              value={question.value?.notes ?? ''}
              label={`Notes — ${question.label}`}
              onChange={(notes) => onAnswer({ ...(question.value ?? {}), notes })}
            />
          </Box>
        )}
      </>
    ) : (
      <DiscoveryReadOnlyAnswer question={question} />
    )}
  </Box>
);
